"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeStandardAvailableMinutes = computeStandardAvailableMinutes;
/**
 * standard_available_minutes = gross_shift_minutes - standard_break_minutes
 * (contract §C). Pure arithmetic, no rounding — both inputs are whole minutes.
 */
function computeStandardAvailableMinutes(input) {
    return input.grossShiftMinutes - input.standardBreakMinutes;
}
//# sourceMappingURL=work-time.js.map